import * as React from 'react';
import './paymentListPane.module.scss';
import { observer, inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { PaymentListPaneState } from './states/PaymentListPaneState';
import { observable, makeObservable } from 'mobx';
import { V3Routes } from '../../../routes';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { SettingPane, PaneSubHeader } from '../../molecules/mypage/page';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { PaymentView } from './PaymentView';
import { CurrentCardSummary } from '../payments/CurrentCardSummary';
import { CurrentCardPlaceholder } from '../payments/CurrentCardPlaceholder';

type Props = {
  homeState: HomePageState;
};

export const PaymentListPane = inject('homeState')(
  observer(
    class PaymentListPane extends React.Component<Props> {
      pageState = new PaymentListPaneState();

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });
      }

      componentDidMount(): void {
        this.pageState.init();
      }

      render() {
        const cardSummary = this.pageState.cardSummary.getOrElse(null);
        const payments = this.pageState.payments.getOrElse([]);
        return (
          <SettingPane activeMenu="payments" title="お支払い情報 / 履歴" id="payment-list-pane">
            {this.pageState.cardSummary.loading && <LoaderRow />}
            {cardSummary && (
              <CurrentCardSummary
                cardSummary={cardSummary}
                onRequestUpdate={() => GlobalStatesV3.routing.push(V3Routes.payment_info())}
              />
            )}
            {!this.pageState.cardSummary.loading && !cardSummary && (
              <CurrentCardPlaceholder onRequestCreate={() => GlobalStatesV3.routing.push(V3Routes.payment_info())} />
            )}
            <PaneSubHeader title="お支払い履歴" />
            {this.pageState.payments.loading && <LoaderRow />}
            {payments.map((payment, i) => (
              <PaymentView payment={payment} showAction={true} key={i} />
            ))}
          </SettingPane>
        );
      }
    }
  )
);
